import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { EnableFor } from '../../../../../../../../__legacy__/containers/EnableForRole';
import { NameField } from '../../../commons/ui/fields/NameField';
import { IEditMarkingToolBl } from '../../EditMarkingTool.bl';
import { useEditMarkingToolPermissions } from '../../EditMarkingTool.permissions';
import { IEditMarkingToolStore } from '../../EditMarkingTool.store';

export const NameFieldContainer = observer((): ReactElement => {
  const bl = useInjection(IEditMarkingToolBl.$);
  const store = useInjection(IEditMarkingToolStore.$);
  const permissions = useEditMarkingToolPermissions();

  const handleChange = (name: string): void => {
    bl.changeName(name);
  };

  return (
    <EnableFor hasPermission={permissions.canChangeName()}>
      <NameField
        changeName={handleChange}
        name={store.name}
        nameStatus={store.nameStatus}
      />
    </EnableFor>
  );
});
